(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPaths", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/learningPathsView.html",
            controller: ["learningPathResource", "frameworkService", "$sessionStorage", "$scope", "$state", "$translate", "$timeout", "DTOptionsBuilder", "DTColumnDefBuilder", LearningPathsCtrl],
            controllerAs: "vm"
        };
        function LearningPathsCtrl(learningPathResource, frameworkService, $sessionStorage, $scope, $state, $translate, $timeout, DTOptionsBuilder, DTColumnDefBuilder) {
            //NOTE: Tried converting to use promise, dynamically hiding and showing columns didn't work.
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.loading = true;
            vm.catalogEnabled = frameworkService.data.tenantFeatures.storefront || frameworkService.data.tenantFeatures.catalog;
            vm.openBadgesEnabled = frameworkService.data.tenantFeatures.openBadges;
            vm.statuses = [{ "id": 1, "status": "Enabled" }, { "id": 0, "status": "Disabled" }];
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "asc"])
                .withPaginationType("full_numbers")
                .withOption("rowCallback", rowCallback)
                .withBootstrap();
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0).withOption("class", "control").withOption("sortable", false).withOption("targets", 0),
                DTColumnDefBuilder.newColumnDef(1).withOption("searchable", true).withOption("sortable", true),
                DTColumnDefBuilder.newColumnDef(2).withOption("searchable", false).withOption("sortable", true),
                DTColumnDefBuilder.newColumnDef(3).withOption("searchable", true).withOption("sortable", false),
                DTColumnDefBuilder.newColumnDef(4).withOption("searchable", false).withOption("sortable", true).withOption("type", "date"),
            ];
            if ($sessionStorage.manageLearningPathsFilters2) {
                vm.filters = $sessionStorage.manageLearningPathsFilters2;
            }
            else {
                vm.filters = {
                    pathName: { enabled: true, value: "" },
                    status: { enabled: true, value: [1] }
                };
            }
            learningPathResource.getList(function (data) {
                vm.learningPaths = data;
                vm.loading = false;
            });
            vm.reloadTable = function () {
                $timeout(function () {
                    $sessionStorage.manageLearningPathsFilters2 = vm.filters;
                    if (vm.filters.pathName.enabled && vm.filters.pathName.value !== "") {
                        vm.dtInstance.DataTable.column(1).search(vm.filters.pathName.value).draw();
                    }
                    else {
                        vm.dtInstance.DataTable.column(1).search("").draw();
                    }
                    if (vm.filters.status.enabled) {
                        var status = vm.filters.status.value.join("|");
                        if (status === "1")
                            vm.dtInstance.DataTable.column(3).search("true").draw();
                        else if (status === "0")
                            vm.dtInstance.DataTable.column(3).search("false").draw();
                        else
                            vm.dtInstance.DataTable.column(3).search("").draw();
                    }
                    else {
                        vm.dtInstance.DataTable.column(3).search("").draw();
                    }
                });
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.manageLearningPathsFilters2 = vm.filters;
                // reload only if filtered
                if (value && value.length > 0)
                    vm.reloadTable();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                if (vm.filters[filter].hasOwnProperty("value")) {
                    if (vm.filters[filter].value.hasOwnProperty("name"))
                        vm.refreshFilter(vm.filters[filter].value.name);
                    else
                        vm.refreshFilter(vm.filters[filter].value);
                }
                else if (vm.filters[filter].hasOwnProperty("fromValue")) {
                    vm.refreshFilter(vm.filters[filter].fromValue + vm.filters[filter].toValue);
                }
            };
            function rowClickHandler(row) {
                $state.go("main.learningItems.learningPathVersion", { number: row[2] });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    $scope.$apply(function () {
                        rowClickHandler(aData);
                    });
                });
                return nRow;
            }
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
                //EXAMPLE - use saved state unless its first time on page (and you need to apply filters)
                if (vm.dtInstance.DataTable.state().start === 0)
                    vm.reloadTable();
            };
            //vm.search = function () {
            //	$sessionStorage.manageLearningPathsFilters = { search: vm.dtSearch };
            //	vm.dtInstance.DataTable.search(vm.dtSearch).draw();
            //};
            //vm.configureStorefront = function (number, version) {
            //	$state.go("main.learningItems.learningPathVersionStorefront.information", { number: number, version: version });
            //};
            //vm.configureOpenBadges = function (number, version) {
            //	$state.go("main.learningItems.learningPathVersionOpenBadges", { number: number, version: version });
            //};
        }
    });
}());
